import { Box, Button, Typography } from "@mui/material";

export default function OrderSent({onClick}) {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        zIndex: 1301,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#ffffff",
          padding: "2.5rem 3rem",
          borderRadius: "12px",
          boxShadow: "0px 6px 30px rgba(0,0,0,0.4)",
          maxWidth: "500px",
          textAlign: "center",
          fontFamily: "Anek Latin",
          color: "#333",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            mb: 2,
            fontFamily: "Anek Latin",
            color: "#A7C667",
            fontWeight: "bold",
          }}
        >
          Success!
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontFamily: "Anek Latin", mb: 1, color: "#5A6872" }}
        >
          Your art service order has been sent!
        </Typography>
        <Typography
          variant="body1"
          sx={{ fontFamily: "Anek Latin", mb: 3, color: "#5A6872" }}
        >
          Thank you for your order. You’ll receive a confirmation email shortly.<br />
          Please expect a quote within 2-3 business days.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{
            mb: 1,
            backgroundColor: "#A7C667",
            color: "white",
            borderRadius: "8px",
            px: 3,
            py: 0,
            fontWeight: "1000",
            fontFamily: "Anek Latin",
            fontSize: "1.4rem",
            textTransform: "uppercase",
            "&:hover": {
              backgroundColor: "#A7C667",
            },
          }}
          onClick={onClick}
        >
          Return Home
        </Button>
      </Box>
    </Box>
  );
}
